import React, { useState, useEffect } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import Swal from "sweetalert2";
import ProfileNavbar from "../Component/ProfileNavbar";
import defaultImage from "../Component/img/event1.jfif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import noevent from "../Component/img/no-event-bg.png";

const MyEvent = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      const visitorId = localStorage.getItem("visitor_id");

      console.log("visitorId", visitorId);
      if (!visitorId) {
        Swal.fire({
          title: "Error",
          text: "Please login to see your events",
          icon: "error",
          confirmButtonText: "OK"
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/login";
          }
        });
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}submitedformByVisitorId/${visitorId}`);
        console.log("response",response);
        if (response.data.success) {
          // Ensure the events data is always an array
          setEvents(response.data.events || []);
        } else {
          Swal.fire("Error", response.data.message || "No events found", "error");
          setEvents([]); // If no events found, set events as an empty array
        }
      } catch (error) {
        console.error("Error fetching events:", error);
        Swal.fire("Error", "Failed to fetch events", "error");
        setEvents([]); // In case of error, set events to empty
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return (
    <>
      <NavbarVisitor />
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <ProfileNavbar />
            </div>
            <div className="col-md-9">
              <div className="bg-salt mt-3 p-2 py-3 mb-3 text-start">
                <h2 className="hedng">My Events</h2>

                {loading ? (
                  <p>Loading...</p>
                ) : events.length === 0 ? (
                  <div>
                    <img src={noevent} className="img-fluid" alt="No events" />
                  </div>
                ) : (
                  events.map((event) => (
                    <div className="row mb-3" key={event.event_unique_id}>
                      <div className="col-md-4">
                        <img
                          src={event.image || defaultImage}
                          className="img-fluid imgevtpro"
                          alt={event.event_name}
                        />
                      </div>
                      <div className="col-md-8">
                        <div className="event-details text-start p-1">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-gradient-primary etype">
                              {event.event_type?.toUpperCase()}
                            </span>
                            <span className="ft-tags">
                              {new Date(event.start_date).toLocaleDateString()} -{" "}
                              {new Date(event.end_date).toLocaleDateString()}
                            </span>
                          </div>
                          <h4 className="ft-event">{event.event_name}</h4>
                          <div>
                            <span className="ft-tags">
                              <FontAwesomeIcon icon={faMapLocationDot} />{" "}
                              {event.venue_address || "Venue Not Available"}
                            </span>
                          </div>
                          <div className="mt-2">
                            <Link
                              to={
                                event.event_type === "exhibition" || event.event_type === "conference"
                                  ? `/${event.event_type}/${event.event_slug}`
                                  : `/${event.event_slug}/${event.event_type}`
                              }
                              target="_blank"
                              className="viwmr"
                            >
                              View Details
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default MyEvent;
